import AdminMerchantModal from "./adminMerchantModal";

/** @deprecated Use AdminMerchantModal with mode="create" */
const AdminMerchantAdd = (props) => (
  <AdminMerchantModal mode="create" {...props} />
);

export default AdminMerchantAdd;
